import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getAppParams, getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./AddictionAssessment.css";
import { APIV4_BASE_URL } from "../apiService/apiClient";

const downloadPdf = (reportUrl) => {
  if (!reportUrl) return;
  const link = document.createElement("a");
  link.href = reportUrl;
  link.setAttribute("download", "report.pdf");
  link.style.display = "none";
  document.body.appendChild(link);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isIOS) window.open(reportUrl, "_blank");
  else link.click();
  document.body.removeChild(link);
};

const getNicotineLabel = (s) => {
  if (s === 0) return { label: "No Dependence", color: "#66bb6a" };
  if (s <= 2) return { label: "Low Dependence", color: "#42a5f5" };
  if (s <= 4) return { label: "Moderate Dependence", color: "#FBC525" };
  if (s <= 7) return { label: "High Dependence", color: "#ffa726" };
  return { label: "Very High Dependence", color: "#ef5350" };
};
const getDrugLabel = (s) => {
  if (s <= 2) return { label: "No Dependence", color: "#66bb6a" };
  if (s <= 5) return { label: "Low Dependence", color: "#66bb6a" };
  if (s <= 8) return { label: "Moderate Dependence", color: "#42a5f5" };
  if (s <= 12) return { label: "High Dependence", color: "#FBC525" };
  return { label: "Very High Dependence", color: "#ffa726" };
};
const getAlcoholLabel = (s) => {
  if (s <= 7) return { label: "No Dependence", color: "#66bb6a" };
  if (s <= 15) return { label: "Low Dependence", color: "#42a5f5" };
  if (s <= 19) return { label: "Moderate Dependence", color: "#ffa726" };
  if (s <= 20) return { label: "High Dependence", color: "#ffa726" };
  return { label: "Very High Dependence", color: "#ef5350" };
};

const NICOTINE_QS = [
  { questionId: 17, question: "Do you smoke or have you ever smoked?", options: ["Yes, I currently smoke.", "No, I have never smoked.", "I used to smoke but I have quit."] },
  { questionId: 18, question: "How soon after you wake do you smoke your first cigarette?", options: ["Within 5 minutes", "6-30 minutes", "31-60 minutes", "After 60 minutes"] },
  { questionId: 19, question: "Do you find it difficult to refrain from smoking in places where it is forbidden?", options: ["Yes", "No"] },
  { questionId: 20, question: "Which cigarette would you hate most to give up?", options: ["The first one in the morning", "All others"] },
  { questionId: 21, question: "How many cigarettes do you typically smoke per day?", options: ["10 or less", "11-20", "21-30", "31 or more"] },
  { questionId: 22, question: "Do you smoke more frequently during the first hours after waking than during the rest of the day?", options: ["Yes", "No"] },
  { questionId: 23, question: "Do you smoke even if you are so ill that you are in bed most of the day?", options: ["Yes", "No"] },
];
const DRUG_QS = [
  { questionId: 24, question: "Have you used drugs other than those required for medical reasons?", options: ["Yes, I currently use drugs.", "No, I have never used drugs.", "I used to use drugs but have quit."] },
  { questionId: 25, question: "Do you use more than one drug at a time?", options: ["YES", "NO"] },
  { questionId: 26, question: "Are you always able to stop using drugs when you want to?", options: ["YES", "NO"] },
  { questionId: 27, question: "Have you had \"blackouts\" or \"flashbacks\" as a result of drug use?", options: ["YES", "NO"] },
  { questionId: 28, question: "Do you ever feel bad or guilty about your drug use?", options: ["YES", "NO"] },
  { questionId: 29, question: "Does your spouse (or parents) ever complain about your involvement with drugs?", options: ["YES", "NO"] },
  { questionId: 30, question: "Have you neglected your family because of your use of drugs?", options: ["YES", "NO"] },
  { questionId: 31, question: "Have you engaged in illegal activities to obtain drugs?", options: ["YES", "NO"] },
  { questionId: 32, question: "Have you ever experienced withdrawal symptoms when you stopped taking drugs?", options: ["YES", "NO"] },
  { questionId: 33, question: "Have you had medical problems as a result of your drug use?", options: ["YES", "NO"] },
  { questionId: 34, question: "Have you gone to anyone for help for a drug problem?", options: ["YES", "NO"] },
  { questionId: 35, question: "Have you been involved in a treatment program specifically for drug use?", options: ["YES", "NO"] },
  { questionId: 36, question: "Do you take drugs more often than you intended?", options: ["YES", "NO"] },
  { questionId: 37, question: "Have you overdosed on drugs?", options: ["YES", "NO"] },
  { questionId: 38, question: "Do you avoid people or places that don’t approve of your drug use?", options: ["YES", "NO"] },
  { questionId: 39, question: "Have you lost interest in activities or hobbies due to drug use?", options: ["YES", "NO"] },
  { questionId: 40, question: "Have you had legal problems due to your drug use?", options: ["YES", "NO"] },
  { questionId: 41, question: "Have you used drugs to relieve feelings of sadness, anger, or boredom?", options: ["YES", "NO"] },
  { questionId: 42, question: "Have you continued to use drugs despite negative consequences?", options: ["YES", "NO"] },
  { questionId: 43, question: "Have you tried and failed to stop using drugs?", options: ["YES", "NO"] },
];
const ALCOHOL_QS = [
  { questionId: 44, question: "Do you drink alcohol or have you ever drunk?", options: ["Yes, I currently drink Alcohol.", "No, I have never had Alcohol.", "I used to but I have quit."] },
  { questionId: 45, question: "How often do you have a drink containing alcohol?", options: ["Never", "Monthly or less", "2-4 times a month", "2-3 times a week", "4 or more times a week"] },
  { questionId: 46, question: "How many standard drinks containing alcohol do you have on a typical day when drinking?", options: ["1 or 2", "3 or 4", "5 or 6", "7 to 9", "10 or more"] },
  { questionId: 47, question: "How often do you have six or more drinks on one occasion?", options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"] },
  { questionId: 48, question: "How often have you found that you were not able to stop drinking once you had started?", options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"] },
  { questionId: 49, question: "How often have you failed to do what was normally expected of you because of drinking?", options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"] },
  { questionId: 50, question: "How often have you needed a drink in the morning to get yourself going after a heavy drinking session?", options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"] },
  { questionId: 51, question: "How often have you had a feeling of guilt or remorse after drinking?", options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"] },
  { questionId: 52, question: "How often have you been unable to remember what happened the night before because you had been drinking?", options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"] },
  { questionId: 53, question: "Have you or someone else been injured as a result of your drinking?", options: ["No", "Yes, but not in the past year", "Yes, during the past year"] },
  { questionId: 54, question: "Has a relative or friend, doctor or other health worker been concerned about your drinking or suggested you cut down?", options: ["No", "Yes, but not in the past year", "Yes, during the past year"] },
];

const ALL_QS_MAP = [...NICOTINE_QS, ...DRUG_QS, ...ALCOHOL_QS].reduce((acc, q) => { acc[q.questionId] = q; return acc; }, {});

const ScoreBar = ({ segments }) => (
  <div className="ad-score-bar-labels">
    {segments.map(([color, label, dark], i) => (
      <div key={i} className={`ad-score-bar-seg${dark ? " dark-text" : ""}`} style={{ backgroundColor: color }}>{label}</div>
    ))}
  </div>
);

const ColorBar = ({ score, sections }) => (
  <div className="ad-color-bar">
    {sections.map((s, i) => {
      const active = score >= s.start && score <= s.end;
      return (
        <div key={i} className="ad-color-seg" style={{
          flex: 1,
          backgroundColor: active ? s.color : "var(--bg-surface)",
          borderRight: i < sections.length - 1 ? "2px solid var(--bg-card)" : "none",
        }} />
      );
    })}
  </div>
);

const renderQA = (qsList, questions) => {
  if (!questions?.length) return null;
  const ansMap = {};
  questions.forEach((q) => { ansMap[parseInt(q.questionId, 10)] = parseInt(q.answer, 10); });
  return qsList
    .filter((q) => q.questionId in ansMap)
    .map((q, i) => {
      const idx = ansMap[q.questionId];
      return (
        <div key={i} className="ad-report-qa">
          <p><strong>Q {i + 1}:</strong> {q.question}</p>
          <p><strong>{q.options[idx] ?? "-"}</strong></p>
        </div>
      );
    });
};

const AddictionAssessment = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const { goqiiUserId, nonce, apiKey, signature, goqiiAccessToken, appVersion, appType } = getAppParams();

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    if (lang === "ar") document.documentElement.dir = "rtl";
  }, [theme, lang]);

  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState([]);
  const [view, setView] = useState("dashboard");
  const [currentResult, setCurrentResult] = useState(null);

  const buildQs = useCallback((extra = {}) =>
    new URLSearchParams({ goqiiUserId, nonce, signature, apiKey, goqiiAccessToken, appVersion, appType, ...extra }).toString(),
    [goqiiUserId, nonce, signature, apiKey, goqiiAccessToken, appVersion, appType]
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const qs = buildQs({ type: "addiction" });
        const res = await fetch(`${APIV4_BASE_URL}/lab/fetch_mental_health_assessment?${qs}`);
        const json = await res.json();
        if (json.data?.code === 200) {
          const formatted = json.data.assessmentData.map((item) => ({
            date: item.createdTime,
            anxietyScore: parseInt(item.anxietyScore, 10),
            depressionScore: parseInt(item.depressionScore, 10),
            wellnessScore: parseInt(item.mentalWellnessScore, 10),
            anxietyLabel: item.anxietyLabel,
            depressionLabel: item.depressionLabel,
            wellnessLabel: item.mentalWellnessLabel,
            reportUrl: item.reportUrl,
            personalDetails: { name: `${json.data.firstName} ${json.data.lastName}`, age: json.data.age, gender: json.data.gender },
            questions: item.questions,
          }));
          setResults(formatted);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [buildQs]);

  const goTo = (path) => { window.location.href = `${path}${window.location.search}`; };

  if (loading) {
    return (
      <div className="ad-wrapper">
        {[1, 2, 3].map((i) => <div key={i} className="ad-shimmer-card" />)}
      </div>
    );
  }

  /* ---- REPORT VIEW ---- */
  if (view === "report" && currentResult) {
    const isSmokingDrug = !!currentResult.anxietyLabel;
    const isAlcohol = !!currentResult.wellnessLabel && !currentResult.anxietyLabel;
    const title = isSmokingDrug ? "Smoking/Nicotine and Drug Assessment" : "Alcohol Assessment";

    const getNicotineRec = (s) => {
      if (s === 0) return "You do not smoke or have successfully quit. Maintain your smoke-free lifestyle for lasting health benefits.";
      if (s <= 2) return "Mild nicotine dependence detected. Gradually reduce smoking and seek advice if needed.";
      if (s <= 5) return "Moderate nicotine addiction detected. Behavioral therapy or nicotine replacement strategies can help manage your dependence.";
      if (s <= 8) return "Significant nicotine dependence identified. Seek professional support and explore cessation strategies for a healthier lifestyle.";
      return "Strong nicotine addiction detected. Professional guidance, including counseling or medications, is strongly recommended for effective cessation.";
    };
    const getDrugRec = (s) => {
      if (s <= 2) return "No immediate action needed. Stay informed about the risks of drug use.";
      if (s <= 5) return "Consider a brief intervention or check-in with a healthcare provider.";
      if (s <= 8) return "It's important to speak with a health professional. Possibly treatment is recommended.";
      if (s <= 12) return "A comprehensive evaluation is essential. Consider therapy, counseling, or treatment programs.";
      return "Urgent professional help is needed. Seek treatment immediately, including inpatient care or therapy.";
    };
    const getAlcRec = (s) => {
      if (s <= 7) return "No current alcohol-related concerns. Maintain a healthy, alcohol-free lifestyle.";
      if (s <= 15) return "Potential hazardous drinking behavior. Brief counseling or monitoring is recommended.";
      if (s <= 19) return "Likely harmful drinking patterns detected. Seek healthcare professional support.";
      return "Strong likelihood of alcohol dependence. Immediate referral for addiction treatment or specialized professional support is advised.";
    };

    return (
      <div className="ad-wrapper">
        <div className="ad-report">
          <div className="ad-report-header">
            <img src="https://appcdn.goqii.com/storeimg/21983_1778484667.png" alt="GOQii" className="ad-report-logo" />
          </div>
          <p className="ad-report-title">{title}</p>
          <p className="ad-report-date">{t("addictionAssessment.dateOfAssessment")}: {currentResult.date}</p>
          <hr className="ad-divider" />

          <p className="ad-report-section-title">{t("addictionAssessment.personalDetails")}</p>
          <p className="ad-report-row"><strong>{t("addictionAssessment.name")}:</strong> {currentResult.personalDetails.name}</p>
          <p className="ad-report-row"><strong>{t("addictionAssessment.age")}:</strong> {currentResult.personalDetails.age}</p>
          <p className="ad-report-row"><strong>{t("addictionAssessment.gender")}:</strong> {currentResult.personalDetails.gender}</p>
          <hr className="ad-divider" />

          {isSmokingDrug && (
            <>
              <p className="ad-report-section-title">Nicotine Assessment Result</p>
              <div className="ad-score-bar-nums">
                {["0","0-2","3-4","5-7","8-10"].map((n,i) => <div key={i} className="ad-score-bar-num">{n}</div>)}
              </div>
              <ScoreBar segments={[["#008000","No Dependence",false],["#4a90e2","Low Dependence",false],["#f5a623","Moderate",false],["#FBC525","High",true],["#d0021b","Very High",false]]} />
              <p className="ad-score-text"><strong>Score: {currentResult.anxietyScore} (out of 10) — {currentResult.anxietyLabel}</strong></p>
              <p className="ad-score-note">Your answers indicate that you have {currentResult.anxietyLabel} on Smoking/Nicotine.</p>
              <hr className="ad-divider" />
              <p className="ad-report-section-title">Recommended Action:</p>
              <p className="ad-report-small">{getNicotineRec(currentResult.anxietyScore)}</p>
              <div className="ad-gradient-divider" />
              <p className="ad-report-section-title">Nicotine Risk</p>
              <p className="ad-report-small"><strong>Result: {currentResult.anxietyScore} (out of 10) - {currentResult.anxietyLabel}</strong></p>
              {renderQA(NICOTINE_QS, currentResult.questions)}
              <div className="ad-gradient-divider" />

              <p className="ad-report-section-title">Drug Assessment Result</p>
              <div className="ad-score-bar-nums">
                {["0-2","3-5","6-8","9-12","13-20"].map((n,i) => <div key={i} className="ad-score-bar-num">{n}</div>)}
              </div>
              <ScoreBar segments={[["#008000","No Dependence",false],["#4a90e2","Low",false],["#f5a623","Moderate",false],["#FBC525","High",true],["#d0021b","Very High",false]]} />
              <p className="ad-score-text"><strong>Score: {currentResult.depressionScore} (out of 20) — {currentResult.depressionLabel}</strong></p>
              <p className="ad-score-note">Your answers indicate that you have {currentResult.depressionLabel} on Drug.</p>
              <hr className="ad-divider" />
              <p className="ad-report-section-title">Recommended Action:</p>
              <p className="ad-report-small">{getDrugRec(currentResult.depressionScore)}</p>
              <div className="ad-gradient-divider" />
              <p className="ad-report-section-title">Drug Risk</p>
              <p className="ad-report-small"><strong>Result: {currentResult.depressionScore} (out of 20) - {currentResult.depressionLabel}</strong></p>
              {renderQA(DRUG_QS, currentResult.questions)}
              <div className="ad-gradient-divider" />
              <p className="ad-report-disclaimer"><strong>Disclaimer:</strong> The Fagerstrom Test for Nicotine Dependence and the Drug Abuse Screening Test (DAST-20) are screening tools and not diagnostic instruments. Results are based on self-reported data. This report is for informational purposes only and should not replace professional medical advice.</p>
              <div className="ad-gradient-divider" />
            </>
          )}

          {currentResult.wellnessLabel && (
            <>
              <p className="ad-report-section-title">Alcohol Assessment Result</p>
              <div className="ad-score-bar-nums">
                {["0-7","8-15","16-19","19-20","20-48"].map((n,i) => <div key={i} className="ad-score-bar-num">{n}</div>)}
              </div>
              <ScoreBar segments={[["#008000","No Dependence",false],["#4a90e2","Low",false],["#f5a623","Moderate",false],["#FBC525","High",true],["#d0021b","Very High",false]]} />
              <p className="ad-score-text"><strong>Score: {currentResult.wellnessScore} (out of 40) — {currentResult.wellnessLabel}</strong></p>
              <p className="ad-score-note">Your answers indicate that you have {currentResult.wellnessLabel} on Alcohol.</p>
              <hr className="ad-divider" />
              <p className="ad-report-section-title">Recommended Action:</p>
              <p className="ad-report-small">{getAlcRec(currentResult.wellnessScore)}</p>
              <div className="ad-gradient-divider" />
              <p className="ad-report-section-title">Alcohol Risk</p>
              <p className="ad-report-small"><strong>Result: {currentResult.wellnessScore} (out of 40) - {currentResult.wellnessLabel}</strong></p>
              {renderQA(ALCOHOL_QS, currentResult.questions)}
              <div className="ad-gradient-divider" />
              <p className="ad-report-disclaimer"><strong>Disclaimer:</strong> The Alcohol Use Disorders Identification Test (AUDIT) is a screening tool and not a diagnostic instrument. Results are based on self-reported data. This report is for informational purposes only and should not replace professional medical advice.</p>
              <div className="ad-gradient-divider" />
            </>
          )}

          <div className="ad-report-actions">
            <button className="ad-btn-outline" onClick={() => setView("dashboard")}>{t("addictionAssessment.close")}</button>
            <button className="ad-btn-contained" onClick={() => downloadPdf(currentResult.reportUrl)}>{t("addictionAssessment.downloadPdf")}</button>
          </div>
        </div>
      </div>
    );
  }

  /* ---- DASHBOARD VIEW ---- */
  return (
    <div className="ad-wrapper">
      <div className="ad-hero">
        <img src="https://appcdn.goqii.com/storeimg/96315_1778484783.png" alt="Addiction Assessment" className="ad-hero-img" />
      </div>
      <p className="ad-desc">{t("addictionAssessment.desc")}</p>
      <button className="ad-btn-primary" onClick={() => goTo("/nicotinedrug_assessment")}>{t("addictionAssessment.smokingBtn")}</button>
      <button className="ad-btn-primary" onClick={() => goTo("/alchohol_assessment")}>{t("addictionAssessment.alcoholBtn")}</button>

      <hr className="ad-divider" />

      <p className="ad-section-title">{t("addictionAssessment.previousAssessments")}</p>

      {results.length === 0 ? (
        <p className="ad-empty-text">{t("addictionAssessment.noAssessments")}</p>
      ) : (
        results.map((r, idx) => {
          const hasNicotine = !!r.anxietyLabel;
          const hasDrug = !!r.depressionLabel;
          const hasAlcohol = !!r.wellnessLabel;
          return (
            <div key={idx} className="ad-card" onClick={() => { setCurrentResult(r); setView("report"); }}>
              <p className="ad-card-date">{r.date}</p>
              {hasNicotine && (
                <div className="ad-card-row">
                  <span className="ad-card-label">Smoking/Nicotine Risk:</span>
                  <span className="ad-card-value">{getNicotineLabel(r.anxietyScore).label}</span>
                </div>
              )}
              {hasDrug && (
                <div className="ad-card-row">
                  <span className="ad-card-label">Drug Addiction Risk:</span>
                  <span className="ad-card-value">{getDrugLabel(r.depressionScore).label}</span>
                </div>
              )}
              {hasAlcohol && (
                <div className="ad-card-row">
                  <span className="ad-card-label">Alcohol Addiction Risk:</span>
                  <span className="ad-card-value">{getAlcoholLabel(r.wellnessScore).label}</span>
                </div>
              )}
              <div className="ad-card-actions">
                <button className="ad-btn-outline" onClick={(e) => { e.stopPropagation(); setCurrentResult(r); setView("report"); }}>{t("addictionAssessment.viewReport")}</button>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default AddictionAssessment;
